import { Link } from 'react-router-dom';

import { Logo } from '@/components/Logo';
import { CONTACT_EMAIL } from '@/features/legal/contact';
import type { LandingCopy } from './copy';
import { WhatsAppButton } from './WhatsAppButton';

/** "For developers" opens the folded developer section, then the browser jumps to it. */
const openUnderTheHood = () => {
  const details = document.getElementById('under-the-hood');
  if (details instanceof HTMLDetailsElement) details.open = true;
};

export const Footer = ({
  copy,
  linkProps,
}: {
  copy: LandingCopy;
  linkProps: Record<string, () => void>;
}) => {
  const { footer } = copy;
  return (
    <footer className="lp-footer">
      <div className="lp-container">
        <div className="lp-footer__grid">
          <div className="lp-footer__about">
            <span className="lp-brand lp-brand--footer">
              <Logo size={22} />
              <span>Order Bot</span>
            </span>
            <p>{footer.tagline}</p>
          </div>

          <div>
            <p className="lp-footer__title">{footer.productTitle}</p>
            <ul>
              <li>
                <a href="#how-it-works">{copy.nav.how}</a>
              </li>
              <li>
                <a href="#pricing">{copy.nav.pricing}</a>
              </li>
              <li>
                <a href="#faq">{copy.nav.faq}</a>
              </li>
              <li>
                <Link to="/demo" {...linkProps}>
                  {footer.demo}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="lp-footer__title">{footer.contactTitle}</p>
            <ul>
              <li>
                <WhatsAppButton
                  label={footer.whatsapp}
                  text={copy.closing.whatsappText}
                  className="lp-footer__chat"
                />
              </li>
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`}>
                  {footer.email}: {CONTACT_EMAIL}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="lp-footer__title">{footer.accountTitle}</p>
            <ul>
              <li>
                <Link to="/login" {...linkProps}>
                  {footer.staffLogin}
                </Link>
              </li>
              <li>
                <Link to="/signup" {...linkProps}>
                  {footer.signup}
                </Link>
              </li>
              <li>
                <Link to="/privacy">{footer.privacy}</Link>
              </li>
              <li>
                <Link to="/terms">{footer.terms}</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="lp-footer__bottom">
          <span>© {new Date().getFullYear()} Order Bot</span>
          <a href="#under-the-hood" onClick={openUnderTheHood}>
            {footer.developers}
          </a>
        </div>
      </div>
    </footer>
  );
};
